import { render, staticRenderFns } from "./ModalCategoriaFiltroMobile.vue?vue&type=template&id=45aafba4&scoped=true"
import script from "./ModalCategoriaFiltroMobile.vue?vue&type=script&lang=js"
export * from "./ModalCategoriaFiltroMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalCategoriaFiltroMobile.vue?vue&type=style&index=0&id=45aafba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aafba4",
  null
  
)

export default component.exports